import React from 'react';

import css from './SectionCreators.module.css';
import classNames from 'classnames';
import { H2, H3 } from '../../../components';

import Creator1Image from '../images/michael.jpeg';
import Creator2Image from '../images/jack.jpeg';
import { lazyLoadWithDimensions } from '../../../util/uiHelpers';

const Image = props => {
  const { alt, ...rest } = props;

  return <img {...rest} alt={alt} />;
};

const LazyImage = lazyLoadWithDimensions(Image, {
  loadAfterInitialRendering: 3000,
});

const creators = [
  {
    image: Creator1Image,
    name: 'AboutUsPage.creators.1.name',
    title: 'AboutUsPage.creators.1.title',
    factsList: [
      'AboutUsPage.creators.1.fact1',
      'AboutUsPage.creators.1.fact2',
      'AboutUsPage.creators.1.fact3',
      'AboutUsPage.creators.1.fact4',
    ],
  },
  {
    image: Creator2Image,
    name: 'AboutUsPage.creators.2.name',
    title: 'AboutUsPage.creators.2.title',
    factsList: [
      'AboutUsPage.creators.2.fact1',
      'AboutUsPage.creators.2.fact2',
      'AboutUsPage.creators.2.fact3',
      'AboutUsPage.creators.2.fact4',
    ],
  },
];

const SectionCreators = props => {
  const { className, intl } = props;

  return (
    <div className={classNames(css.root, className)}>
      <H2 className={css.h2}>
        {intl.formatMessage(
          { id: 'AboutUsPage.creators.heading' },
          { span: text => <span className={css.marketplaceColoredText}>{text}</span> }
        )}
      </H2>
      <p className={css.description}>
        {intl.formatMessage(
          { id: 'AboutUsPage.creators.description' },
          { span: text => <span className={css.bold}>{text}</span> }
        )}
      </p>
      <div className={css.sectionsWrapper}>
        {creators.map((creator, index) => (
          <React.Fragment key={creator.name}>
            <div className={css.section}>
              <div className={css.imgContainer}>
                <LazyImage src={creator.image} alt="" />
              </div>
              <H3 className={css.h3}>{intl.formatMessage({ id: creator.name })}</H3>
              <span className={css.subtitle}>{intl.formatMessage({ id: creator.title })}</span>
              <ul className={css.factList}>
                {creator.factsList.map(fact => (
                  <li className={css.fact} key={fact}>
                    {intl.formatMessage({ id: fact })}
                  </li>
                ))}
              </ul>
            </div>
            {index !== creators.length - 1 && <hr className={css.divider} />}
          </React.Fragment>
        ))}
      </div>
      <div className={css.bottomText}>
        {intl.formatMessage({ id: 'AboutUsPage.creators.bottomText' })}
      </div>
    </div>
  );
};

export default SectionCreators;
